import { render, staticRenderFns } from "./AccountInfoList.vue?vue&type=template&id=a201fe20&scoped=true"
import script from "./AccountInfoList.vue?vue&type=script&lang=js"
export * from "./AccountInfoList.vue?vue&type=script&lang=js"
import style0 from "./AccountInfoList.vue?vue&type=style&index=0&id=a201fe20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a201fe20",
  null
  
)

export default component.exports